import * as symbol from './symbol';
import * as utils from './utils';
export function getLocalTargetSymbol(typeChecker, node) {
    return utils.getValueOrUndefined(typeChecker.getExportSpecifierLocalTargetSymbol(node));
}
export function getLocalTargetDeclarations(typeChecker, node) {
    const localSymbol = getLocalTargetSymbol(typeChecker, node);
    if (localSymbol === undefined) {
        return [];
    }
    return symbol.getDeclarations(localSymbol);
}

//# sourceMappingURL=exportSpecifier.js.map
